module.exports = __webpack_public_path__ + "img/gonetworksj2.05f8f3f9.png";